/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_Not_ConnectedInputs */

const cs_listing_portals_not_connected = /** @type {(inputs: Listing_Portals_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřipojeno`)
};

const en_listing_portals_not_connected = /** @type {(inputs: Listing_Portals_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected`)
};

/**
* | output |
* | --- |
* | "Not connected" |
*
* @param {Listing_Portals_Not_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_not_connected = /** @type {((inputs?: Listing_Portals_Not_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_Not_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_not_connected(inputs)
	return cs_listing_portals_not_connected(inputs)
});